import * as z from "zod";

import { PaymentMethod } from "@modules/checkout/enums/payment-method";
import { PaymentStatus } from "@modules/checkout/enums/payment-status";
import { RawDateTimeSchema } from "@shared/schemas/date";

import { PaymentStatusSchema } from "./payment-status.schema";

export const PixPaymentAttemptSchema = z
  .object({
    ExtraData: z
      .object({
        Code: z.string(),
        Location: z.url(),
        CreatedAt: RawDateTimeSchema,
        DueAt: RawDateTimeSchema,
        ExpireAt: RawDateTimeSchema,
      })
      .nullable(),
    Status: PaymentStatusSchema.nullable().optional().default(null),
    Method: z.literal(PaymentMethod.PIX),
  })
  .transform((payload) => {
    if (payload.Status === PaymentStatus.Created || payload.Status === PaymentStatus.Failed) {
      return { ...payload, ExtraData: null };
    }
    return payload;
  });
